<script setup>
import { swalError } from '@/helper';
import { retrieve_child } from '@/services/child';
import { onMounted, ref } from 'vue';
import child_card from '../dnaReport/component/child_card.vue';
import { useRoute } from 'vue-router';
import reportRow from './component/reportRow.vue'
import { retrieve_report } from '@/services/report';
import { get_packages } from '@/services/option';

const route = useRoute()
const isLoading = ref(true)
onMounted(async()=>{
  await get_child()
  isLoading.value = false
  await parse_intervention()
})

const isParsing = ref(true)
const child = ref({})
async function get_child(){
  let response = await retrieve_child(route.params.id)
  console.log("🚀 ~ get_child ~ response:", response)
  if(response.error){
    swalError(response.result, true)
    return
  }
  child.value = response.result.data.child.data
}

async function parse_intervention(){
  const needEmptyCard = {total: child.value.relationships.reports.data.length, hit: 0}
  let remaining_trait = 0
  const reports = await Promise.all(child.value.relationships.reports.data.map( async (report) => {
    let report_response = await retrieve_report(report.id)
    let intervention_traits = report_response.result.data.included.map( report_stats =>{
      if (report_stats.attributes.is_intervention){
        return report_stats
      }else{
        return null
      }
    })
    
    // get package config if included is exist
    if (report_response.result.data.data.attributes.document){
      let package_config_response = await get_packages()
      package_config_response = package_config_response.result.find(item => item.id == report_response.result.data.data.attributes.report_type)
      remaining_trait += parseInt(package_config_response.options.trait_val.value)
    }

    // remove null value
    intervention_traits = intervention_traits.filter(item => {
      return item !== null
    })

    remaining_trait -= intervention_traits.length
    if (intervention_traits.length == 0){
      needEmptyCard.hit++
    }
    return {
      report: report_response.result.data.data,
      intervention_traits,
    }
  }))
  
  reports.sort((a, b) => {
    return Number(a.report.id) - Number(b.report.id);
  });

  child.value = {
    ...child.value,
    reports,
    remaining_trait,
    needEmptyCard: needEmptyCard.hit == needEmptyCard.total ? true : false
  }
  isParsing.value = false
}
</script>

<template>
  <div class="container-fluid">
    <Breadcrumbs main="Child Report"/>
    <loadingCard v-if="isLoading"/>
    <template v-else>
      <child_card :child="child"/>
      <loadingCard v-if="isParsing" />
      <template v-else>
        <template v-for="report in child.reports" :key="report.report.id">
          <reportRow :child="child" :report="report"/>
        </template>
      </template>
    </template>
  </div>
</template>